import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { GenerationWaterBlock } from '../../report/GenerationImpactProjectionBlocks';

/**
 * P3.2 — Water duty of the promoted generation scenario, on Generation &
 * Impact. The same frozen `generationImpactProjection.waterResource` block
 * Water Resource renders inside Supply Availability; here it is the whole
 * section, because the duty is a property of the chosen equipment, not of the
 * site's water entitlement. No narrative: the figures are solver output and
 * the model is never asked to reconcile them with the site-boundary screen.
 */
export const WaterDutySection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const hasPromotedScenario = !!report.generationImpactProjection?.waterResource;
  return (
    <SectionShell
      label={label}
      sectionId="waterDuty"
      hasData={hasPromotedScenario}
      emptyMessage="No generation scenario has been promoted for this site, so no water duty is stated. Promote a scenario in Generation & Impact and regenerate."
    >
      <GenerationWaterBlock report={report} />
    </SectionShell>
  );
};
